import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Sticker from './pages/Sticker';
import Course from './pages/Course';


const App = () => {

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/st/:id" exact component={Sticker} />
        <Route path="/courses/:id/pricing" component={Course} />
        <Route path="/" exact component={Home} />
        <Route component={Login} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
